import { UpdateAttendanceDepartment } from '../../../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ShiftTimePicker from '../ShiftTimePicker';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomModal from '../../../../../../../components/Modal/CustomModal';
import moment from 'moment';
import { ErrorCode } from '../../../../../../../Apis/ErrorCode';
import { errorMsg } from '../../../../../../../Apis/functions';
import HandleChange from '../../../../../../../Helpers/HandleChange';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param show - Boolean to determine if the schedule update modal should be shown
 * @param onHide - Function to hide the modal when triggered
 * @param setModified - Function to set the updated status flag after schedule update
 * @param dataUpdate - The data to be used for updating the schedule
 */
const UpdateSchedule = ({ show, onHide, setModified, item, setItem, departmentId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [selectedList, setSelectedList] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);
    const { handleChange: baseHandleChange } = HandleChange({ model: item, setModel: setItem });
    const handleUpdate = () => {
        if (!item.isValid()) {
            setEmptyFields(true);
            return;
        }
        const supervisorIds = selectedList.map((s) => s.userId);
      
        dispatch(UpdateAttendanceDepartment(item.toAddEdit(supervisorIds))).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success === true) {
                    toast.success(t('has_been_updated_successfully'));
                    setModified(true);
                    onHide();
                } else errorMsg(code);
            },
        );
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        baseHandleChange({
            target: {
                name,
                value: item.normalizeValue(name, value),
            },
        });
    };

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            onConfirm={handleUpdate}
            title='update'
            size='lg'
            cancelButton={true}
            confirmButton={true}
        >
            <div className='row px-0'>
                <ShiftTimePicker
                    showNoSelectionOption={false}
                    item={item}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    displayNone={!item?.departmentId}
                />
            </div>
        </CustomModal>
    );
};

export default UpdateSchedule;
